// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_page_container, .not_found_page_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 0px;
  display: flex;
  padding: 30px;
  height: 100%;
  color: white;
  width: calc(100% - 60px);
  z-index: 2;
}

.not_found_page_container {
  align-items: center;
}

.loading_page_container {
  flex-direction: column;
  row-gap: 50px;
  column-gap: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  height: 100%;
}

.error-message {
  color: #ffffff;
  text-align: center;
}

.main_page_container {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-areas: "cards cards cards car car";
  gap: 10px;
  z-index: 2;
  padding: 0px 100px;
  color: white;
  width: calc(100% - 200px);
}

@media (max-width: 1100px) {
  .main_page_container {
    padding: 0px 50px;
    width: calc(100% - 100px);
    grid-template-areas: "cards" "car";
    justify-content: center;
  }
}
@media (max-width: 500px) {
  .main_page_container {
    padding: 0px 20px;
    width: calc(100% - 40px);
  }
}
.progress_line {
  background: linear-gradient(to left, #1087FF, #00CCC4);
  color: transparent;
  height: 8px;
}

.progress {
  background: linear-gradient(to left, #1087FF, #00CCC4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.loading_bar {
  width: 300px;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  align-items: center;
}

.home-link {
  background: linear-gradient(to left, #1087FF, #00CCC4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/pages/pages.sass"],"names":[],"mappings":"AAMA;EALE,sBAM2B;EAL3B,aAKmC;EAJnC,eAIyC;EAHzC,aAAA;EAIA,aAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,UAAA;AAFF;;AAGA;EACE,mBAAA;AAAF;;AACA;EAdE,sBAe2B;EAd3B,aAcmC;EAbnC,eAayC;EAZzC,aAAA;EAaA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAKF;;AAHA;EACE,cAAA;EACA,kBAAA;AAMF;;AAJA;EACE,aAAA;EACA,uBAAA;EACA,gDAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAOF;;AALA;EACE;IACE,iBAAA;IACA,yBAAA;IACA,kCAAA;IACA,uBAAA;EAQF;AACF;AARA;EACE;IACE,iBAAA;IACA,wBAAA;EAUF;AACF;AAPA;EACE,sDAAA;EACA,kBAAA;EACA,WAAA;AASF;;AAPA;EACE,sDAAA;EACA,6BAAA;EACA,oCAAA;AAUF;;AARA;EACE,YAAA;EA3DA,mBA4D2B;EA3D3B,aA2DgC;EA1DhC,gBA0DsC;EAzDtC,aAAA;EA0DA,mBAAA;AAcF;;AAbA;EACE,sDAAA;EACA,6BAAA;EACA,oCAAA;AAgBF","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\n.login_page_container, .not_found_page_container\n  @include default_container(column, 10px, 0px)\n  padding: 30px\n  height: 100%\n  color: white\n  width: calc(100% - 60px)\n  z-index: 2\n.not_found_page_container\n  align-items: center\n.loading_page_container\n  @include default_container(column, 50px, 0px)\n  justify-content: center\n  align-items: center\n  padding: 30px\n  height: 100%\n\n.error-message\n  color: #ffffff\n  text-align: center\n\n.main_page_container\n  display: grid\n  grid-template-rows: 1fr\n  grid-template-areas: 'cards cards cards car car'\n  gap: 10px\n  z-index: 2\n  padding: 0px 100px\n  color: white\n  width: calc(100% - 200px)\n\n@media (max-width: 1100px)\n  .main_page_container\n    padding: 0px 50px\n    width: calc(100% - 100px)\n    grid-template-areas: 'cards' 'car'\n    justify-content: center\n@media (max-width: 500px)\n  .main_page_container\n    padding: 0px 20px\n    width: calc(100% - 40px)\n    //grid-template-areas: 'cards' 'car'\n    //justify-content: center\n\n.progress_line\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  color: transparent\n  height: 8px\n\n.progress\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n\n.loading_bar\n  width: 300px\n  @include default_container(row, 10px, 10px)\n  align-items: center\n.home-link\n  background: linear-gradient(to left, #1087FF, #00CCC4)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n  //text-decoration: underline linear-gradient(to right, #F08319, #E51B2F)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
